
import React from 'react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Michael Rodriguez',
      age: 42,
      location: 'Austin, TX',
      treatment: 'Growth Hormone Peptides + BPC-157',
      quote: 'After 3 months of peptide therapy, my recovery time has dramatically improved. I\'m sleeping better, have more energy, and my chronic shoulder pain is completely gone.',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/606d418ee299a38376b7dacb93a3897c.jpg'
    },
    {
      name: 'Sarah Chen',
      age: 38,
      location: 'San Francisco, CA',
      treatment: 'Cognitive Enhancement + Metabolic Peptides',
      quote: 'The mental clarity and focus I\'ve gained from peptide therapy has been life-changing. I\'ve also lost 15 pounds and feel more energetic than I have in years.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20woman%20in%20her%20late%20thirties%2C%20warm%20smile%2C%20business%20casual%20attire%2C%20clean%20white%20background%2C%20professional%20headshot%20for%20medical%20testimonial&width=300&height=300&seq=sarah-testimonial&orientation=squarish'
    },
    {
      name: 'David Thompson',
      age: 45,
      location: 'Denver, CO',
      treatment: 'Performance Enhancement Protocol',
      quote: 'As an athlete, peptide therapy has taken my performance to the next level. Faster recovery, increased strength, and better endurance. The results speak for themselves.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Athletic%20middle-aged%20Caucasian%20man%2C%20confident%20expression%2C%20fitness%20attire%2C%20clean%20white%20background%2C%20professional%20headshot%20for%20sports%20medicine%20testimonial&width=300&height=300&seq=david-testimonial&orientation=squarish'
    },
    {
      name: 'Jennifer Williams',
      age: 51,
      location: 'Miami, FL',
      treatment: 'Anti-Aging + Immune Support',
      quote: 'I feel like I\'ve turned back the clock 10 years. My skin looks better, I have more energy, and I rarely get sick anymore. Peptide therapy has been incredible.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Elegant%20middle-aged%20African%20American%20woman%2C%20radiant%20smile%2C%20professional%20attire%2C%20clean%20white%20background%2C%20professional%20headshot%20for%20anti-aging%20testimonial&width=300&height=300&seq=jennifer-testimonial&orientation=squarish'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            Real Results from <strong>Peptide Therapy</strong>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Discover how our patients have transformed their health and performance with personalized peptide protocols.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg p-6 lg:p-8">
              <div className="flex items-start space-x-4 mb-6">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top"
                />
                <div className="flex-1">
                  <h4 className="font-bold text-gray-900 text-lg">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">Age {testimonial.age} • {testimonial.location}</p>
                  <p className="text-blue-600 text-sm font-medium mt-1">{testimonial.treatment}</p>
                </div>
                <div className="flex space-x-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
              </div>
              
              <blockquote className="text-gray-700 leading-relaxed italic">
                "{testimonial.quote}"
              </blockquote>
            </div>
          ))}
        </div>

        <div className="mt-12 lg:mt-16 text-center">
          <div className="bg-blue-50 rounded-2xl p-6 lg:p-8 max-w-4xl mx-auto">
            <div className="grid sm:grid-cols-3 gap-6 lg:gap-8 mb-6">
              <div>
                <div className="text-2xl lg:text-3xl font-bold text-blue-600 mb-2">98%</div>
                <div className="text-gray-600">Patient Satisfaction</div>
              </div>
              <div>
                <div className="text-2xl lg:text-3xl font-bold text-blue-600 mb-2">2,500+</div>
                <div className="text-gray-600">Successful Treatments</div>
              </div>
              <div>
                <div className="text-2xl lg:text-3xl font-bold text-blue-600 mb-2">5+ Years</div>
                <div className="text-gray-600">Clinical Experience</div>
              </div>
            </div>
            <button className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-4 rounded-xl font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Join Our Success Stories
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
